import React, { FC, ReactNode, StrictMode } from 'react'
import { Loader } from '../../components/Loader/Loader'

type ContentLayoutProps = {
  isLoading: boolean
  children: ReactNode
}

export const ContentLayout: FC<ContentLayoutProps> = ({
  children,
  isLoading
}) => {
  return (
    <div>{isLoading ? <Loader /> : <StrictMode>{children}</StrictMode>}</div>
  )
}
